import { useSelector } from 'react-redux';

import VersionAsset from '../../controls/asset/VersionAsset';

import AssetRibbonSelectors from 'pages/home/ribbon/asset-full/controllers/selectors';

const VersionsSection = (props) => {
  const isCreating = useSelector(AssetRibbonSelectors.selectAssetCreating());
  const sectionDisabled =
    isCreating || window.location.pathname === '/asset/create';

  return <VersionAsset sectionDisabled={sectionDisabled} />;
};

VersionsSection.propTypes = {};

VersionsSection.defaultProps = {};

export default VersionsSection;
